<modal-component
    [title]="modalTitle"
    [data]="{
        resizeOrClose:'close',
        okBtnTitle:'',
        cancelBtnTitle: '',
        footerMessage: 'Access your original file to correct errors. Upload corrected file.'
    }">
    <table class="table" id="validationErrorsTable" aria-describedby="Validation Errors Table">
        <thead>
            <tr><th class="error-header" scope="col">Error&nbsp;Location</th><th scope="col">Description</th></tr>
        </thead>
        <tbody>
            <tr *ngFor="let error of modalErrors">
                <td class="error-cell">{{error.location}}</td>
                <td class="error-cell">{{error.description}}</td>
            </tr>
        </tbody>
    </table>
</modal-component>
